import { LitElement, html, css } from 'lit'
import { navigate } from '../router.js'
import { api } from '../api.js'
import { authCardStyles } from './auth-styles.js'

// Client self-registration. On success the account is created 'pending' and a
// verification email is sent; sign-in is blocked until the email is verified.
class PageRegister extends LitElement {
  static properties = {
    _email: { state: true },
    _password: { state: true },
    _fullName: { state: true },
    _error: { state: true },
    _busy: { state: true },
    _sent: { state: true }
  }

  static styles = authCardStyles

  constructor() {
    super()
    this._email = ''
    this._password = ''
    this._fullName = ''
    this._error = ''
    this._busy = false
    this._sent = false
  }

  async _submit(e) {
    e.preventDefault()
    this._error = ''
    this._busy = true
    try {
      await api.post('/auth/register', {
        email: this._email.trim(),
        password: this._password,
        fullName: this._fullName.trim() || undefined
      })
      this._sent = true
    } catch (err) {
      this._error = err.code === 'EMAIL_IN_USE'
        ? 'An account with this email already exists. Try signing in.'
        : (err.message || 'Registration failed.')
    } finally {
      this._busy = false
    }
  }

  render() {
    if (this._sent) {
      return html`
        <div class="card">
          <h1>Check your email</h1>
          <div class="success">
            We sent a verification link to <strong>${this._email}</strong>.
            Open it to finish setting up your account.
          </div>
          <div class="links" style="justify-content:center;margin-top:1.25rem">
            <a @click=${() => navigate('/login')}>Back to sign in</a>
          </div>
        </div>
      `
    }
    return html`
      <div class="card">
        <h1>Create your account</h1>
        <p class="sub">Register with your work email to open support requests.</p>
        ${this._error ? html`<div class="error">${this._error}</div>` : ''}
        <form @submit=${this._submit}>
          <label>Full name
            <input type="text" autocomplete="name"
              .value=${this._fullName} @input=${e => (this._fullName = e.target.value)} />
          </label>
          <label>Email
            <input type="email" required autocomplete="email"
              .value=${this._email} @input=${e => (this._email = e.target.value)} />
          </label>
          <label>Password
            <input type="password" required minlength="8" autocomplete="new-password"
              .value=${this._password} @input=${e => (this._password = e.target.value)} />
          </label>
          <button class="primary" type="submit" ?disabled=${this._busy}>
            ${this._busy ? 'Creating…' : 'Create account'}
          </button>
        </form>
        <div class="links" style="justify-content:center">
          <a @click=${() => navigate('/login')}>Already have an account? Sign in</a>
        </div>
      </div>
    `
  }
}

customElements.define('page-register', PageRegister)
